const DriverSettlement = () =>
	import(
		/* webpackChunkName: "reports-statistics" */ '@/pages/report/driver-settlement/index.vue'
	)

export default {
	path: 'settlement',
	meta: {
		label: 'Settlement',
		auth: 'settlement'
	},
	component: {
		name: 'Driver',
		render(c) {
			return c('router-view')
		}
	},
	children: [
		{
			name: 'DriverSettlementReport',
			path: 'driver',
			meta: {
				label: 'report'
			},
			component: DriverSettlement
		}
	]
}
